'use client';

import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import { IconButton } from '@mui/material';
import { useState } from 'react';
import ShareJobOpportunityModal from './share-job-oppotunity-modal';

export default function ShareJobButton({ link, utmContent }: { link: string; utmContent: string }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <span className="share_job_button">
      <IconButton
        onClick={(e: any) => {
          e.preventDefault();
          setIsModalOpen(true);
        }}
        aria-label="Compartilhar vaga"
      >
        <ShareOutlinedIcon aria-hidden="true" />
        {/* <Image height={22} width={22} src={iconShare} alt="Compartilhar" /> */}
      </IconButton>
      <ShareJobOpportunityModal
        open={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
        link={link}
        utmContent={utmContent}
      />
    </span>
  );
}
